import type { ReactNode } from "react"

import { cn } from "@/lib/utils"

// The selectable option card used across the Review Responder wizard steps —
// the blue-gradient selected treatment from the approved design prototype.
export function OptionCard({
  selected,
  onClick,
  title,
  description,
  className,
  descriptionClassName,
}: {
  selected: boolean
  onClick: () => void
  title: ReactNode
  description?: ReactNode
  className?: string
  descriptionClassName?: string
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "flex flex-col rounded-lg border p-4 text-left transition-colors",
        selected
          ? "border-blue-300 bg-gradient-to-b from-blue-50 to-white dark:from-blue-950/60 dark:to-blue-900/20"
          : "border-border hover:bg-muted/30",
        className,
      )}
    >
      <p
        className={cn(
          "text-sm leading-tight font-semibold",
          selected && "text-blue-600 dark:text-blue-400",
        )}
      >
        {title}
      </p>
      {description && (
        <p
          className={cn(
            "mt-0.5 text-xs leading-relaxed",
            selected
              ? "text-blue-600 dark:text-blue-400"
              : "text-muted-foreground",
            descriptionClassName,
          )}
        >
          {description}
        </p>
      )}
    </button>
  )
}
